// @ts-nocheck
import { apiRequest } from "../../services/apiService";
import {
  FETCH_EMAIL_DATA_FAILURE,
  FETCH_EMAIL_DATA_REQUEST,
  FETCH_EMAIL_DATA_SUCCESS,
} from "../constants/emailRedirectionConstants";

export const fetchEmailDataAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_EMAIL_DATA_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getEmailLinkData",
      params: payload?.params,
      isToken: true,
    });
    if (response?.status == 200) {
      dispatch({ type: FETCH_EMAIL_DATA_SUCCESS });
      successCallback?.(response);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_EMAIL_DATA_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};